{
  "title": "Manual review",
  "subtitle": "Orders held at ingest because a merchant SKU has no Sino mapping. Map the SKU and retry.",
  "col_order": "Order",
  "col_channel": "Channel",
  "col_created": "Created",
  "col_sku": "Unmapped SKU",
  "col_resolve": "Resolve",
  "ph_sino": "Sino SKU",
  "btn_resolve_retry": "Resolve & retry",
  "err_sino_required": "Enter a Sino SKU",
  "err_unknown_sino": "Sino SKU not found in the SKU registry",
  "toast_retried": "Order {{id}} re-queued for ingest",
  "toast_next_sku": "Mapping saved — the order has another unmapped SKU",
  "toast_not_retryable": "Order is no longer retryable; queue refreshed",
  "empty": "Queue is clear — no orders waiting for manual review",
  "loading": "Loading review queue…",
  "error": "Failed to load the review queue",
  "btn_retry_all": "Retry all",
  "toast_bulk_done": "Re-queued {{attempted}} orders: {{locked}} locked, {{stillHeld}} still held",
  "toast_bulk_empty": "No ingest-stage holds found — nothing to retry",
  "toast_bulk_failed": "Bulk retry failed — please try again",
  "readonly_hint": "Resolving requires write access"
}
